import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {BaseComponent} from 'web/components/BaseComponent';
import enumList from 'web/utils/enumList';
import useDetailActions from './hooks/useDetail';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {showMessage} from 'web/utils/modalHelper';
const {moduleEnums, accessModeEnums, caseFlgStatus} = enumList;

const DetailPage = (props) => {
  const baseComponent = new BaseComponent(props);
  const {isCreate} = props;

  const defaultDisableConfigs = !(
    (!isCreate &&
      baseComponent.checkPermission(
        moduleEnums.appearance,
        accessModeEnums.update,
      )) ||
    (isCreate &&
      baseComponent.checkPermission(
        moduleEnums.appearance,
        accessModeEnums.create,
      ))
  );

  const defaultConfigs = {
    code: '',
    name: '',
    description: '',
    flgStatus: caseFlgStatus.open,
    skills: [],
  };

  const navigate = useNavigate();
  const {id} = useParams();
  const [skills, setSkills] = useState([]);
  const [configs, realSetConfigs] = useState(
    JSON.parse(JSON.stringify(defaultConfigs)),
  );
  const [invalidShow, setInvalidShow] = useState('none');
  const [isDisabled, toggleIsDisabled] = useState(defaultDisableConfigs);
  const {
    fetchData: fetchAppearanceDetail,
    fetchSkills,
    create: executeCreateAppearance,
    update: executeUpdateAppearance,
  } = useDetailActions();

  const goBack = () => {
    navigate(-1);
  };

  const setConfigs = (newConfigs) => {
    const allows = ['code', 'name', 'description', 'skills'];
    const pendingUpdateNewConfigs = {};
    for (const allow of allows) {
      if (newConfigs[allow] === undefined) {
        continue;
      }
      pendingUpdateNewConfigs[allow] = newConfigs[allow];
    }
    realSetConfigs({
      ...configs,
      ...pendingUpdateNewConfigs,
    });
  };

  const getSkills = async () => {
    const data = await fetchSkills();
    setSkills(
      data
        .filter(({flgStatus}) => flgStatus !== enumList.flgStatus.inactive)
        .map(({conditionCode: code, conditionName: name}) => ({code, name})),
    );
  };

  const handleSkillChange = (e) => {
    const skillCode = e.target.value;
    let newSkills = [...configs.skills];
    if (e.target.checked) {
      newSkills.push(skillCode);
      newSkills = newSkills.sort();
    } else {
      const index = newSkills.indexOf(skillCode);
      console.log(index);
      if (index < 0 || index >= newSkills.length) {
        return;
      }
      newSkills.splice(index, 1);
    }
    setConfigs({skills: newSkills});
  };

  const getAppearanceDetail = async () => {
    if (isCreate && !id) {
      return;
    }
    const {
      code,
      name,
      description,
      skills: rawSkills,
      flgStatus,
    } = await fetchAppearanceDetail({id});
    const skills = rawSkills.map(({condition_code: code}) => code);
    realSetConfigs({code, name, description, skills, flgStatus});
  };

  useEffect(() => {
    Promise.all([
      isCreate && id ? undefined : getAppearanceDetail(),
      getSkills(),
    ]).then([]);
    return () => {
      realSetConfigs(JSON.parse(JSON.stringify(defaultConfigs)));
      setSkills([]);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleIsDisabled(true);
    if (
      e.currentTarget.checkValidity() === false ||
      configs.skills.length === 0
    ) {
      setInvalidShow('block');
      toggleIsDisabled(defaultDisableConfigs);
      return;
    }
    try {
      if (isCreate) {
        await executeCreateAppearance({data: configs});
        showMessage(enumList.messageModalMode.info, '現象新增成功');
        realSetConfigs(JSON.parse(JSON.stringify(defaultConfigs)));
      } else {
        await executeUpdateAppearance({id, data: configs});
        showMessage(enumList.messageModalMode.info, '現象修改成功');
        getAppearanceDetail();
      }
    } finally {
      goBack();
      toggleIsDisabled(defaultDisableConfigs);
    }
  };

  return (
    <section id="datatable-container">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="f-fs-sm btn" onClick={goBack}>
            <i className="bi bi-arrow-left me-1"></i>
            回上頁
          </li>
        </ol>
      </nav>
      <form
        className=" needs-validation"
        id="modalResidentForm"
        noValidate
        onSubmit={handleSubmit}
      >
        <div className="modal-body">
          <div className="d-flex flex-column gap-3 px-2">
            <div className="modal__form__catagory row">
              <div className="col-12">
                <div className="d-flex gap-3">
                  <div
                    className={`status status-${
                      configs.flgStatus === caseFlgStatus.open
                        ? 'normal'
                        : 'danger'
                    } mb-2`}
                  >
                    <span>
                      {configs.flgStatus === caseFlgStatus.open ? '已' : '未'}
                      啟用
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="appearance-edit-code"
                      className="form-label"
                    >
                      現象編號*
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="appearance-edit-code"
                      name="appearance-edit-code"
                      value={configs.code}
                      required
                      disabled={isDisabled}
                      onChange={(e) =>
                        setConfigs({code: e.target.value.trim()})
                      }
                    />
                  </div>
                  <div className="col">
                    <label
                      htmlFor="appearance-edit-name"
                      className="form-label"
                    >
                      現象名稱*
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="appearance-edit-name"
                      name="appearance-edit-name"
                      value={configs.name}
                      required
                      disabled={isDisabled}
                      onChange={(e) =>
                        setConfigs({name: e.target.value.trim()})
                      }
                      rows="3"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <label className="form-label mt-2">現象說明</label>
                    <textarea
                      className="form-control"
                      id="description"
                      name="description"
                      value={configs.description}
                      onChange={(e) => {
                        setConfigs({description: e.target.value});
                      }}
                      rows="2"
                      disabled={isDisabled}
                    ></textarea>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <label
                      htmlFor="appearance-edit-conditions"
                      className="form-label"
                    >
                      指派條件*
                    </label>
                    <div className="row g-2">
                      {skills.length > 0 &&
                        skills.map(({code, name}, index) => (
                          <div className="col-4" key={index}>
                            <input
                              type="checkbox"
                              className="btn-check"
                              name="appearance-edit-conditions"
                              id={`appearance-edit-conditions-${code}`}
                              autoComplete="off"
                              value={code}
                              onChange={handleSkillChange}
                              checked={configs.skills.includes(code)}
                              disabled={isDisabled}
                            />
                            <label
                              className="btn btn-sm btn-outline-secondary"
                              htmlFor={`appearance-edit-conditions-${code}`}
                            >
                              {name}
                            </label>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div
              className="alert alert-warning global-invalid-feedback"
              style={{display: invalidShow}}
            ></div>
          </div>
        </div>
        <div className="d-flex justify-content-end w-100">
          <button type="button" className="btn btn-cancel" onClick={goBack}>
            取消
          </button>
          <button type="submit" className="btn btn-primary">
            儲存
          </button>
        </div>
      </form>
    </section>
  );
};

export default DetailPage;
